import React from 'react'
import herobg from '../../../assets/subservice/OxbrytaHero.png'
import MobileHeroBg from  '../../../assets/subservice/OxbrytaHeroMobile.png'

const HomeOne = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Hero Section */}
      <section className="hidden sm:flex relative w-full md:h-[55vh] lg:h-[85vh] items-center justify-center overflow-hidden bg-[#0100AF]">

        {/* Overlay */}
        <div className="absolute inset-0 z-10" />

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-6 md:px-16 lg:px-24 py-8 text-center">
          
          <h1
            className="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4 leading-tight drop-shadow-lg max-w-[900px]"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Turning 65 Soon? <br />
            Here's What You Need To Know About Your Medicare <br />
            Before It's Too Late.
          </h1>

          <h2
            className="text-sm sm:text-base md:text-sm lg:text-xl text-white mb-6 font-medium drop-shadow leading-relaxed max-w-[800px]"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Most people don't realize they can face lifelong penalties for missing a single enrollment window.<br/>
            If you're approaching 65 or already eligible, don't wait.<br/>
            Find out where you stand with a free case review today.
          </h2>

        </div>
      </section>

      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full min-h-[90vh] items-center justify-center overflow-hidden bg-[#0100AF]">

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-5 text-center">

          <h1
            className="text-white text-[24px] min-[400px]:text-[26px] min-[500px]:text-[28px] leading-[32px] font-bold -mt-[80px]"
            style={{ fontFamily: "Quicksand, sans-serif" }}
          >
            Turning 65 Soon? <br/>
            Here's What You Need To Know About <br/>
            Your Medicare Before It's Too Late.
          </h1>

          <h2
            className="text-[14px] min-[400px]:text-[15px] min-[500px]:text-[16px] text-white mt-3 font-normal leading-relaxed max-w-[340px]"
            style={{ fontFamily: "Quicksand, sans-serif" }}
          >
            Most people don't realize they can face lifelong penalties for missing a single enrollment window.<br/>
            If you're approaching 65 or already eligible, don't wait.<br/>
            Find out where you stand with a free case review today.
          </h2>

        </div>

        {/* Overlay */}
        <div className="absolute inset-0 z-10" />

      </section>
    </>
  )
}

export default HomeOne;